module.exports = __webpack_public_path__ + "media/images/application/icons/twitter-logo-0f27e6764254bcd3ce45f89bdd6cdd92.svg";